import React, { CSSProperties } from "react";
import type { DropdownProps } from "semantic-ui-react";
import { FieldRenderProps } from "react-final-form";
import { StyledDropdown as WWDropdown, IGNIS_RED } from "@120wateraudit/waterworks";
import styled from "styled-components";

type Props = FieldRenderProps<string, HTMLElement> & {
  className?: string;
  label?: string;
  style?: CSSProperties;
  wrapperStyling?: CSSProperties;
};

export const Dropdown: React.FC<Props> = ({
  className,
  input,
  label,
  meta: { error },
  style,
  options,
  wrapperStyling,
  ...rest
}: Props) => {
  const handleChange = (
    _event: React.SyntheticEvent<HTMLElement, Event>,
    data: DropdownProps,
  ): void => {
    const val = data?.value;

    const normalized =
      val === undefined
        ? undefined
        : Array.isArray(val)
        ? val.map(String).join(",")
        : Number.isNaN(Number(val))
        ? String(val)
        : Number(val);
    input.onChange(normalized);
  };

  const forwardAsFocusEvent = (
    event: React.SyntheticEvent<HTMLElement, Event>,
  ): React.FocusEvent<HTMLElement> => event as unknown as React.FocusEvent<HTMLElement>;

  const handleFocus = (
    event: React.SyntheticEvent<HTMLElement, Event>,
    _data: DropdownProps,
  ): void => {
    input.onFocus?.(forwardAsFocusEvent(event));
  };

  const handleBlur = (
    event: React.SyntheticEvent<HTMLElement, Event>,
    _data: DropdownProps,
  ): void => {
    input.onBlur?.(forwardAsFocusEvent(event));
  };

  return (
    <Wrapper style={wrapperStyling}>
      <FieldDropdown
        style={style}
        error={error}
        className={className}
        name={input.name}
        value={input.value}
        label={label}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        options={options}
        {...rest}
      />
    </Wrapper>
  );
};

const FieldDropdown = styled(WWDropdown)`
  &&& {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 0px;

    select {
      padding-left: 0.7em;
      border-width: 1px;
      border-color: ${(props: { error?: string | boolean | undefined }) =>
        props.error ? IGNIS_RED : "rgba(34, 36, 38, .15)"} !important;
    }

    label {
      margin-right: auto;
    }
  }
`;

const Wrapper = styled.div`
  margin: 24px;
`;

export default Dropdown;
